class ct_header extends HTMLElement {
  constructor() {
    super();
    this.scrollThreshold = 50;
    this.lastScrollPosition = window.scrollY;
    this.scrollHideThreshold = 35;
    this.handleScroll = this.handleScroll.bind(this);
    this.handleMenuHover();
    this.setChildMenuTop();
    this.querySelector(".ct-header-mobile-hamburger svg").addEventListener("click", () => {
      const menuDrawer = document.querySelector("ct-drawer-navigation");
      menuDrawer.toggleDrawer();
    });
    document.body.style.setProperty("--ct-header-height", (this.offsetHeight + 5) +"px");
  }
  setChildMenuTop() {
    const ctwheight = this.querySelector(".ct-wrapper").offsetHeight;
    const menuitemheight = this.querySelector(".ct-header-menu-item")?.offsetHeight || 12;
    const headerheight = this.offsetHeight;
    const paddingBottom = parseFloat(window.getComputedStyle(this).getPropertyValue("padding-bottom"));
    const topValue = ((ctwheight - menuitemheight) / 2) + menuitemheight + paddingBottom /*+ borderwidth*/;
    this.querySelector(".ct-header-menu").style.setProperty("--ct-header-dropdown-top", topValue + "px");

    const wishlist = this.querySelector(".ct-header-wishlist");
    if(wishlist) {
      const wishlistHeight = wishlist.offsetHeight;
      const topValue2 = ((ctwheight - wishlistHeight) / 2) + wishlistHeight + paddingBottom;
      wishlist.querySelector(".ct-header-wishlist-list").style.top = topValue2 + "px";
    }
  }
  connectedCallback() {
    window.ctHeaderOverflow?.(this);
    window.addEventListener("scroll", this.handleScroll);
    this.handleScroll();
    this.buildWishList();
    this.toggleWishlist();
  }
  disconnectedCallback() {
    this.ctOverflowCleanup?.();
    window.removeEventListener("scroll", this.handleScroll);
  }
  handleMenuHover() {
    let menuItems = Array.from(this.querySelectorAll(".ct-header-menu-item"));
    //menuItems.push(this.querySelector(".ct-header-wishlist"));
    menuItems.forEach((menuItem) => {
      let isHovering = false;
      let hoverTimeout;
      menuItem.addEventListener("mouseenter", () => {
        menuItem.setAttribute("hovering", "");
        isHovering = true;
        clearTimeout(hoverTimeout);
      });
      menuItem.addEventListener("mouseleave", () => {
        isHovering = false;
        hoverTimeout = setTimeout(() => {
          if(!isHovering) {
            menuItem.removeAttribute("hovering");
          }
        }, 200);
      });
    });
  }
  toggleWishlist() {
    const wlIcon = this.querySelector(".ct-header-wishlist");
    const wishlistMenu = this.querySelector(".ct-header-wishlist-list");    
    wlIcon.addEventListener("click", (e) => {
      e.stopPropagation();
      if (wlIcon.hasAttribute("open")) {
        wlIcon.removeAttribute("open");
      } else {
        wlIcon.setAttribute("open", "");
      }
    });
    document.addEventListener("click", (e) => {
      if (e.target !== wishlistMenu && e.target !== wlIcon) {
        if (wlIcon.hasAttribute("open")) {
          wlIcon.removeAttribute("open");
        }
      }
    });
    wishlistMenu.addEventListener("click", (e) => {
      e.stopPropagation();
    });
    let leaveInterval;
    wishlistMenu.addEventListener("mouseleave", () => {
      leaveInterval = setInterval(() => {
        if (wlIcon.hasAttribute("open")) {
          wlIcon.removeAttribute("open");
        }
      }, 3000);
    });
    wishlistMenu.addEventListener("mouseenter", () =>  {
      clearInterval(leaveInterval);
    });
  }
  handleScroll() {
    let currentScrollPosition = window.scrollY;
    if (window.scrollY >= this.scrollThreshold) {
      this.classList.add("ct-inverted");
    } else {
      if (this.hasAttribute("homepage")) {
        this.classList.remove("ct-inverted");
      }
    }
    if(this.hasAttribute("hide-on-scroll")) {
      if(currentScrollPosition - this.lastScrollPosition >= this.scrollHideThreshold) {
        this.classList.add("ct-hide");
        this.lastScrollPosition = window.scrollY;
      } else if(this.lastScrollPosition - currentScrollPosition >= this.scrollHideThreshold) {
        this.classList.remove("ct-hide");
        this.lastScrollPosition = window.scrollY;
      }
      if(window.scrollY <= 0) {
        setTimeout(() => {
          this.classList.remove("ct-hide");
        }, 50);
      }
    }
  }
  buildWishList() {
    const array = JSON.parse(localStorage.getItem("wishlist"));
    if(array) {
      let ItemListCode = ``;
      const promises = array.map(item => {
        return fetch(window.Shopify.routes.root + "products/" + item.handle + ".js")
          .then(response => {
            if(!response.ok) {
              return null;
            }
            return response.json();
          })
          .then(product => {
            if(product == null) {
              return '';
            }
            const price = (product.price_min / 100).toLocaleString('de-DE', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });            
            let is_on_sale = "";
            let priceClass = "ct-product-price-regular";
            if (product.compare_at_price) {
              const cprice = (product.compare_at_price / 100).toLocaleString('de-DE', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              });
              priceClass = "ct-product-price-sale";
              is_on_sale = `<span class="ct-product-price-regular ct-price-sale">${cprice} ${window.ct_currency.symbol}</span>`;
            }            
            const priceSaleDIV = `
              <div class="ct-product-card-pricewrapper">
                <span class="${priceClass}">${price} ${window.ct_currency.symbol}</span>
                ${is_on_sale}
              </div>
            `;            
            return `
              <a href="${product.url}" class="ct-header-wishlist-list-item">
                <div class="ct-header-wishlist-item-left">
                  <img class="ct-header-wishlist-list-item-image" src="${product.images[0]}" width="36" height="36">
                  <div class="ct-header-wishlist-list-item-infos">
                    <span class="ct-header-wishlist-list-item-title">${product.title}</span>
                    ${priceSaleDIV}
                  </div>
                </div>
                <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 12H5m14 0-4 4m4-4-4-4"></path>
                </svg>
              </a>
            `;
          })
          .catch(error => {
            console.error("Fetch error for product:", item.handle, error);
            return ''; // Fehler ignorieren und leere Zeichenkette zurückgeben
          });
      });
      Promise.all(promises).then(items => {
        ItemListCode = items.join('');
        this.querySelector(".ct-header-wishlist-list").innerHTML = ItemListCode;
      });      
    } else {
      this.querySelector(".ct-header-wishlist-list").innerHTML = "<div class='ct-header-wishlist-list-item-empty'><p>Your wishlist is empty.</p></div>";
    }
  }
}
customElements.define("ct-header", ct_header);
